import UploadMedia from "./UploadMedia";
import { FontAwesomeIcon } from "../../../../../../CommonComponents/AssetsHelper";
import { MediaBaseUrl } from "../../../../../../../actions/api";
import { PHOTOBOT_VERSION } from "../../utils";

const PreviewSettings = ({ list, isCheckedList, isCheckedListState, applyPreview, applyPreviewState, mediaType, handleChange, uploadImage, selectChange, handlePopUp }) => {
  const applySelectedImg = (item) => handleChange(applyPreviewState, item);
  const toggleCheckbox = (item) => selectChange(isCheckedListState, isCheckedList.includes(item) ? isCheckedList.filter((v) => v != item) : [...isCheckedList, item]);

  return (
    <div className="pb-backgrounds grid text-center">
      {list.map((item, index) => {
        const src = `${MediaBaseUrl}images/photobooth/${mediaType}/${item}`;
        const isChecked = isCheckedList.includes(item);
        const isSelected = mediaType == 'stickers' ? applyPreview.find(prev => prev?.url === src)?.url ? true : false : applyPreview === item;
        return (
          <div key={index} className={`img rounded overflow-hidden position-relative cursor-pointer ${isSelected ? "border border-primary border-1" : ""}`}>
            {mediaType == "frames" ? <img className="pb_list_user_img" src={`${MediaBaseUrl}images/photobooth/ai-avatar.jpg?v=${PHOTOBOT_VERSION}`} alt="captured-image" width={64} height={64} /> : null}
            <img src={`${src}?v=${PHOTOBOT_VERSION}`} alt={`${mediaType}-${index}`} width={64} height={64} className={`${mediaType == 'frames' ? "pb_list_frames" : ""} object-fit-${mediaType == 'stickers' ? "contain frame sticker-img" : "cover"}`} onClick={() => applySelectedImg(src)} />
            <input type="checkbox" checked={isChecked} onChange={() => toggleCheckbox(item)} />
            <span className="f-center position-absolute rounded checkbox">
              <FontAwesomeIcon type="regular" icon="check" iconClass="text-white" />
            </span>
          </div>
        );
      })}
      <UploadMedia mediaType={mediaType} uploadImage={uploadImage} handlePopUp={handlePopUp} />
    </div>
  );
};

export default PreviewSettings;